import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import TokenUtilizationTable from "./TokenUtilizationTable.jsx";
import SearchPanel from "./SearchPanel.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { connect } from "react-redux";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import moment from "moment/moment";
import { EmptyRecord } from "../../utils/PageUtility";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import { SummaryCard } from "./SummaryCard";
import { appHelpers } from "../../_helpers/index.js";


class PSCUtilization extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMonth: "",
            open: false,
            selectedMonthValue: "",
            selectedAirlineValue: "",
            selectedAirportValue: "",
            airlines: [],
            airports: [],
            AirlineId: '-1',
            AirportId: '-1',
            currentPage: 1,
            pageSize: 10,
            totalCounts: 0,
            records: [],
            pageRequesting: true,
            From: 0,
            TotalPassengers: 0,
            TotalBillablePassengers: 0,
            Amount: 0,
            TotalOutstandingBillablePassengers: 0,
        };
    }

    componentDidMount() {
        let { regionalAirlines, regionalAirports, user } = store.getState();
        const { dispatch } = this.props;
        if (regionalAirlines) {
            this.setState({ regionalAirlines })
        } else {
            dispatch(commonActions.getAllAirlinesRegional());
        }
        if (regionalAirports) {
            this.setState({ regionalAirports })
        } else {
            dispatch(commonActions.getAllAirportsRegional());
        }
        if (user.AppRole === appConstants.ROLES.AIRLINE) {
            let userObj = {...user};
            let userAirline = {value: userObj.AirlineId, label: userObj.AirlineName};
            this.setState({ AirlineId: userAirline }, this.search);
        } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportId: userLocation }, this.search);
        } else if (user.Location) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportId: userLocation }, this.search);
        } else {
            this.search(1);
        }

    }
    componentWillReceiveProps = function (nextProps) {
        const { regionalAirlines, regionalAirports } = nextProps;
        if (regionalAirlines) {
            let modifiedAirline = [...regionalAirlines];
            let allAirlines = {Airline: "All Airlines", AirlineId: "-1"};
            modifiedAirline.unshift(allAirlines);
            this.setState({ airlines: modifiedAirline });
        }
        if (regionalAirports) {
            let modifiedAirport = [...regionalAirports];
            modifiedAirport.unshift({Name: "All Airports",Code: "-1"});
            this.setState({ airports: modifiedAirport });
        }
    };
    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };
    handleSelectChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleReactSelectChange = (value, name) => {
        this.setState({[name.name]: value});
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights") {
            this.setState({[name.name]: "-1"})
        }
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    downloadReport = (type) => {
        const { dispatch } = this.props;
        const { AirlineId, AirportId, StartDate, EndDate } = this.state;
        let payload = {
            StartDate: moment(StartDate).format('YYYY-MM-DD'),
            EndDate: moment(EndDate).format('YYYY-MM-DD'),
            Type: type
        };

        if (AirportId !== '-1')
            payload.AirportCode = AirportId.value;
        if (AirlineId !== '-1')
            payload.AirlineId = AirlineId.value;

        dispatch(alertActions.startRequest());
        commonService.downloadTokenUtilizationRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.success(response.Message));
                    const isBase64 = !!response.base64File;
                    const fileData = response.base64File || response; // filestream is in response directly
                    const mimeType = appHelpers.getMimeTypeFromType(payload.Type);
                    console.log(mimeType, "mimeType");
            
                    appHelpers.downloadFileV2(fileData, "Airline Token Utilization Report", isBase64, mimeType);
                    // if (response.DownloadUrl) {
                    //     appHelpers.downloadFile(response.DownloadUrl, "Airline Token Utilization Report");
                    // } else {
                    //     dispatch(alertActions.error(response.Message));
                    // }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response.join(', ')));
                    this.setState({ pageRequesting: false });
                }
            });
    };

    search = (pageNumber = 1) => {
        const { AirlineId, AirportId, pageSize, StartDate, EndDate } = this.state;
        const { dispatch } = this.props;

        let payload = {
            From: pageNumber, Size: pageSize,
            StartDate: moment(StartDate).format('YYYY-MM-DD'),
            EndDate: moment(EndDate).format('YYYY-MM-DD')
        };

        if (AirportId !== '-1')
            payload.AirportCode = AirportId.value;
        if (AirlineId !== '-1')
            payload.AirlineId = AirlineId.value;

        dispatch(alertActions.startRequest());
        commonService.searchTokenUtilizedRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response.Entity;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const { Reports, TotalOutstandingBillablePassengers, TotalPassengers, TotalBillablePassengers, Amount } = response;
                    this.setState({
                        currentPage: pageNumber, pageRequesting: false,
                        records: Reports, totalCounts: response.TotalCount,
                        TotalOutstandingBillablePassengers, TotalPassengers, TotalBillablePassengers, Amount
                    });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }
            });
    };

    render() {
        const { classes, requesting } = this.props;
        const { AirportId, AirlineId, airlines, airports,
            name, currentPage, pageSize, totalCounts, records,
            pageRequesting, StartDate, EndDate,
            TotalOutstandingBillablePassengers, TotalPassengers, TotalBillablePassengers, Amount
        } = this.state;

        if (pageRequesting)
            return (
                <CircularProgress />
            );

        return (
            <div>
                <GridContainer>
                    <SearchPanel
                        user={this.props.user}
                        airports={airports}
                        airlines={airlines}
                        airline={name}
                        airport={airports}
                        selectChange={this.handleReactSelectChange}
                        handleDateChange={this.handleDateChange}
                        AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
                        AirportId={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (this.props.user.Location) ? AirportId : AirportId.value}
                        StartDate={StartDate}
                        EndDate={EndDate}
                        onSearch={this.search}
                    />
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <SummaryCard
                            classes={classes}
                            passengerCount={TotalPassengers}
                            billablePax={TotalBillablePassengers}
                            outstandingPax={TotalOutstandingBillablePassengers}
                            Amount={Amount}
                        />

                    </GridItem>
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="regional">
                                <h4 className={classes.cardTitleWhite}>
                                Amount Utilization
                </h4>
                                <p className={classes.cardCategoryWhite}>
                                    {`${totalCounts}`}
                                    {
                                        totalCounts === 1 &&
                                        ` record `
                                    }{
                                        totalCounts !== 1 &&
                                        ` records `
                                    }
                                    matched
                </p>
                            </CardHeader>
                            <CardBody>
                                {
                                    !pageRequesting && totalCounts !== 0
                                    &&
                                    <TokenUtilizationTable fetchMore={this.search} pageSize={pageSize} records={records} currentPage={currentPage} totalCounts={totalCounts} />
                                }
                                {
                                    !pageRequesting && totalCounts === 0
                                    &&
                                    <EmptyRecord message={'No record found!'} />

                                }
                            </CardBody>
                            {
                                !pageRequesting && totalCounts !== 0 &&
                                <CardFooter chart>
                                    <div>
                                        <Button type="button" color="info" onClick={() => this.downloadReport("pdf")} disabled={requesting}>
                                            <DownloadIcon />
                                            Download PDF
                                    </Button>
                                        <Button type="button" color="regional" onClick={() => this.downloadReport("excel")} disabled={requesting}>
                                            <DownloadIcon />
                                            Download EXCEL
                                    </Button>
                                    </div>
                                </CardFooter>
                            }
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { alert, regionalAirlines, regionalAirports, user, requesting } = state;
    return {
        alert,
        regionalAirlines,
        regionalAirports,
        user,
        requesting
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(PSCUtilization)));



// WEBPACK FOOTER //
// ./src/Regional-Views/PSCUtilization/Index.jsx